import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WidgetTitle, { ALIGN } from '../../Utils/Widget/Title/Title.jsx';
import { Desktop } from '../../Utils/MediaComponents/MediaComponents';
import styles from './NewPriceCheckWidget.less';
import PriceCheckLink from './Table/PriceCheckLink';
import PriceCheckInfo from './Table/PriceCheckInformation';
import { isRenderedOnServer } from '../../../utils/envUtils';
import actions from '../actions';
import tracking from '../../../tracking/tracking';
import { RLE_BANNER_NEW } from '../../../tracking/trackingNaming';
import { navigateTo, TAB } from '../../Navigation/Menu/menuConfig';
import { isFeatureOn } from "../../../utils/featureSwitchReader";

type NewWidgetProps = {
  type: string;
  visibility: string;
  priceCheckUpdateRealEstateType?: (realEstateType: string) => undefined;
  isFeatureOn: (feature: string) => boolean;
};

export const NewPriceCheckWidget = ({
  visibility,
  type,
  priceCheckUpdateRealEstateType,
  isFeatureOn,
}: NewWidgetProps): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isRenderedOnServer()) {
      return undefined;
    }
    document.body.setAttribute('data-sticky-button', 'true');

    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
    /* @ts-ignore */
    return () => {
      document.body.setAttribute('data-sticky-button', 'false');
    };
  });

  const handleClick = () => {
    tracking.report(RLE_BANNER_NEW);
    if (priceCheckUpdateRealEstateType) {
      priceCheckUpdateRealEstateType('');
    }
    navigateTo(navigate, TAB.priceCheck);
  };

  if (type === 'bigScreen') {
    return (
      <Desktop
        render={() => (
          <div className={`${styles.priceCheckStickyWidget} margin-top-l padding-l`}>
            <div className={`grid grid-flex grid-justify-space-between ${styles.widgetContainer}`}>
              <div className="grid-item one-whole grid-align-center">
                <WidgetTitle
                  id="price-check"
                  useDiv
                  text="Kostenlos Marktwert Ihrer Immobilie errechnen"
                  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
                  // @ts-ignore
                  align={ALIGN.center}
                />
              </div>
              <div className="grid-item one-whole grid-align-center padding-bottom-m">
                <PriceCheckLink value="HOUSE_BUY" icon="is24-icon-building-single-family-house" text="Haus" />
                <PriceCheckLink value="APARTMENT_BUY" icon="is24-icon-building-apartment" text="Wohnung" />
                <PriceCheckLink value="LAND_BUY" icon="is24-icon-property" text="Grundstück" />
              </div>
              <div className="grid-item one-whole grid-align-center">
                <PriceCheckInfo text="Analyse per E-Mail" />
                <PriceCheckInfo text="In nur 3 Minuten fertig" />
                <PriceCheckInfo text="100% kostenlos & unverbindlich" />
              </div>
            </div>
          </div>
        )}
      />
    );
  }

  return (
    <div data-visibility={visibility} className={`padding-vertical-m ${styles.priceCheckStickyButton}`}>
      <button id="price-check-widget-button" type="button" className="button-primary" onClick={() => handleClick()}>
        Immobilienwert berechnen
      </button>
    </div>
  );
};

NewPriceCheckWidget.defaultProps = {
  priceCheckUpdateRealEstateType: () => undefined,
  isFeatureOn,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  priceCheckUpdateRealEstateType: (realEstateType: string) => actions.priceCheckRealEstateType(realEstateType),
};

/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
/* @ts-ignore */
export default connect(mapStateToProps, mapDispatchToProps)(NewPriceCheckWidget);
